import Logger from '../_00_elements/tools/logger/logger';

/**
 * showSubmitLoader
 *
 * @param {string, tag} btnName id, class, or tag name
 * @description Display loader in button specified in param.
 */
export function showSubmitLoader(btn) {
  const btnElement = typeof btn === 'string' ? document.querySelector(btn) : btn;
  const { width } = btnElement.getBoundingClientRect();

  // Disable button to prevent multiple form submission
  btnElement.setAttribute('disabled', 'disabled');

  btnElement.classList.add('loading-btn');
  btnElement.style.width = `${width}px`;

  Logger.debug('Loading...');
}

/**
 * hideSubmitLoader
 *
 * @param {string, tag} btnName id, class, or tag name
 * @description Hide loader in button specified in param.
 */
export function hideSubmitLoader(btn) {
  const btnElement = typeof btn === 'string' ? document.querySelector(btn) : btn;
  btnElement.classList.remove('loading-btn');
  btnElement.removeAttribute('style');
  btnElement.removeAttribute('disabled');

  Logger.debug('Loading... over');
}
